import FinancePaymentsApi from 'api/admins/finance-payments-api'
import { TitlePage } from 'components/atoms'
import { useHistory } from 'react-router-dom'
import FinancePaymentsView from 'domains/finance/payments/view/finance-payments-view'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const FinancePaymentsDetailPage = ({ pageUtils }) => {
  const { id } = useParams()
  const [ payment, setPayment ] = useState({})
  const [ historyList, setHistoryList ] = useState([])
  const [ historyDetail, setHistoryDetail ] = useState({})
  const [ isLoading, setIsLoading ] = useState(true)
  const history = useHistory()

  const confirmDownPayment = async () => {
    setIsLoading(true)

    try {
      await FinancePaymentsApi.confirmDownPayment({ paymentId: id })

      history.push('/app/buying/po-sourcing')
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Request failed"

      pageUtils.setApiErrorMsg(msg)
    } finally {
      setIsLoading(false)
    }
  }

  const updateDownPayment = async (fullyPaid, downPayment) => {
    if (!fullyPaid && downPayment === 0) {
      alert("Mohon isi Down Payment baru")
      return
    }

    setIsLoading(true)

    try {
      await FinancePaymentsApi.updateDownPayment({
        paymentId: id,
        fullyPaid,
        downPayment,
      })

      await fetchPayment()
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Request failed"

      pageUtils.setApiErrorMsg(msg)
    } finally {
      setIsLoading(false)
    }
  }

  const confirmManualTransfer = async () => {
    setIsLoading(true)

    try {
      await FinancePaymentsApi.confirm({ paymentId: id })
      await fetchPayment()
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Request failed"

      pageUtils.setApiErrorMsg(msg)
    } finally {
      setIsLoading(false)
    }
  }
  
  const rejectManualTransfer = async () => {
    setIsLoading(true)

    try {
      await FinancePaymentsApi.reject({ paymentId: id })
      await fetchPayment()
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Request failed"

      pageUtils.setApiErrorMsg(msg)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchPayment = () => {
    setIsLoading(true)

    FinancePaymentsApi.show({ paymentId: id })
      .then((response) => { setPayment(response.data.data) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
      .finally(() => { setIsLoading(false) })
  }
  
  const fetchHistoryList = () => {
    FinancePaymentsApi.listHistory({ dealId: payment.deal.id })
      .then((response) => { setHistoryList(response.data?.data?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
  }
  const fetchHistoryDetail = (id) => {
    FinancePaymentsApi.getHistory({ historyId: id })
      .then((response) => { setHistoryDetail(response.data.data) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
  }
  const clearHistoryDetail = () => {
    setHistoryDetail({})
  }

  useEffect(() => {
    fetchPayment()
  }, [ id ])

  return (
    <>
      <TitlePage mainTitle={ 'Finance Payment' }/>
      <FinancePaymentsView
        confirmManualTransfer={ confirmManualTransfer }
        rejectManualTransfer={ rejectManualTransfer }
        fetchPayment={ fetchPayment }
        updateDownPayment={ updateDownPayment }
        confirmDownPayment={confirmDownPayment}
        payment={ payment }
        fetchHistoryList={ fetchHistoryList }
        fetchHistoryDetail={ fetchHistoryDetail }
        clearHistoryDetail={ clearHistoryDetail }
        historyList={ historyList }
        historyDetail={ historyDetail }
        isLoading={ isLoading }
      />
    </>
  )
}

FinancePaymentsDetailPage.propTypes = propTypes

export default FinancePaymentsDetailPage